<template>

    <el-col
      class="content"
      :xl="{ span: 18 }"
      :lg="{ span: 18 }"
      :md="{ span: 18 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <div class="mydoc">
        <div class="header" style="font-weight: 900">
         【实验语言学】网上研修班
        </div>
        <div class="mybody">
          <p>
            “得语音者得语言。得语言者得天下。”语言学子从哪里入门？应该在语言调查和语言实验中认识语言。
          </p>
          <p>
            我们从1986年第一期语音学讲习班开始，传播语言实验的理念和方法，年复一年，赢得学界口碑。从2017年开始网上直播免费实验语言学研修班。使更多学子踏上语言实验之路，这是一条希望之路，光明之路，成功之路。
          </p>

          <p>
            研修班通过网络直播形式讲解实验语言学原理和实际操作方法。半小时学会语音鼻化度测量分析，一小时学会声调格局分析方法，两小时学会元音格局，三小时学会辅音格局，四小时学会语调韵律格局的基本实验操作方法。可以用于汉语方言、民族语言、语言接触、儿童语言习得、第二语言习得、语言病理和语言类型等多方面的实验分析。
          </p>
          <p>
            实验并不神秘。用实验方法研究语言是一个广阔的领域，大有前途。研修班在每年十月中举办。欢迎有志创新的年轻人来一试身手，大展宏图。
          </p>
        </div>
      </div>
    </el-col>

</template>>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "introduction",
  components: {
    loginComponent,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>


// WEBPACK FOOTER //
// src/view/training.vue